import Header from "../common/header/DefaultHeader";
import MobileMenu from "../common/header/MobileMenu";
import PopupSignInUp from "../common/PopupSignInUp";
import FaqbBanner from "./FaqBanner";
import FaqContent from "./FaqContent";
import HelpTopics from "./HelpTopics";
import MetaComponent from "../common/MetaComponent";
import Accreditation from "./Accreditation";
import OtherLinkFooter from "../common/footer/OtherLinkFooter";
import NewFooter from "../common/footer/NewFooter";

const metadata = {
  title: "Hubzu Support",
};

const index = () => {
  return (
    <>
      <MetaComponent meta={metadata} />
      {/* <!-- Main Header Nav --> */}
      <Header />
      {/* <!--  Mobile Menu --> */}
      <MobileMenu />
      {/* <!-- Modal --> */}
      <PopupSignInUp />
      {/* <!-- Inner Page Breadcrumb --> */}

      <FaqbBanner />
      <HelpTopics />
      <FaqContent />

      <Accreditation />

      {/* <!-- Our Footer --> */}
      {/* <section className="footer_one home6 bg-ptrn2">
        <div className="container">
          <div className="row">
            <Footer />
          </div>
        </div>
      </section> */}
       <div className="container-fluid px-0">
              {/* <Footer /> */}
              <OtherLinkFooter />
              <NewFooter />
            </div>
    </>
  );
};

export default index;
